export default "__VITE_ASSET__DdcIccLf__"